// extracted by mini-css-extract-plugin
module.exports = {"main":"typewriter_main__6vW1x"};